import React from 'react';
import { EventData, Conversation } from '../types';
import SectionButton from './SectionButton';
import headerLogo from '../images/impulse_rgb_positive.png';

interface HomePageProps {
  homepage: EventData['homepage'];
  chatConversations?: Conversation[];
  onNavigate: (type: string, pageId: number | null, url: string | null) => void;
  onLogoClick?: () => void;
}

const HomePage: React.FC<HomePageProps> = ({ homepage, chatConversations, onNavigate, onLogoClick }) => {
  const { sections } = homepage;

  // Calculate total unseen message count
  const totalUnseenCount = chatConversations?.reduce(
    (sum, conv) => sum + (conv.unseenCount || 0),
    0
  ) || 0;

  const isSectionVisible = (section: typeof sections[0]) => {
    const now = new Date();
    
    if (section.showAt) {
      const showAtDate = new Date(section.showAt);
      if (now >= showAtDate) return true;
    }
    
    if (section.hideAt) {
      const hideAtDate = new Date(section.hideAt);
      if (now >= hideAtDate) return false;
    }
    
    return section.isVisible;
  };

  // Sort sections by the 'order' property and filter by visibility
  const visibleSections = [...sections]
    .filter(isSectionVisible)
    .sort((a, b) => a.order - b.order);

  return (
    <div className="p-4 pt-0 md:p-8">
      {/* Logo */}
      <div className="flex justify-center mb-6 md:my-8">
        <div className="h-32 md:h-40 lg:h-48 flex items-center justify-center border-b-1 border-gray-500 p-2 pt-0">
          <button type="button" onClick={onLogoClick} className="h-full">
            <img src={headerLogo} alt="Limbach Logo" className="object-contain h-full"/>
          </button>
        </div>
      </div>

      {/* Section Buttons */}
      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
        {visibleSections.map(section => (
          <SectionButton
            key={section.id}
            title={section.title}
            backgroundColor={section.backgroundColor}
            imageUrl={section.image}
            iconName={section.iconName}
            iconColor={section.iconColor}
            iconFill={section.iconFill}
            iconWeight={section.iconWeight}
            iconGrade={section.iconGrade}
            iconOpticalSize={section.iconOpticalSize}
            badgeCount={section.type === 'chat_conversations' ? totalUnseenCount : undefined}
            onClick={() => onNavigate(section.type, section.pageId, section.url)}
          />
        ))}
      </div>
    </div>
  );
};

export default HomePage;
